import isEmpty from "lodash/isEmpty";
import {Fragment} from "react";
import {FaBan, FaPaperclip} from "react-icons/fa6";

import {HorizontalDivider} from "@/components/HorizontalDivider.tsx";
import {Icon} from "@/components/icon/Icon";
import {Credentials} from "@/lib/types/credentials.ts";
import {CheckUsedInRow} from "@/pages/vault/vaultForm/CheckUsedInRow.tsx";

export const CheckUsedInVaultItem = ({credential}: {credential: Credentials}) => (
  <div>
    <div className={"d-flex mb-3"}>
      <div>
        <FaPaperclip size={16} />
      </div>
      <h6 className={"mb-0 ms-1"}>Used in:</h6>
    </div>
    <div className={"mx-3"}>
      <HorizontalDivider className={"my-2"} />
      {!isEmpty(credential.services) ? (
        credential.services?.map((service) => (
          <Fragment key={service.id}>
            <CheckUsedInRow service={service} />
            <HorizontalDivider className={"my-2"} />
          </Fragment>
        ))
      ) : (
        <div className={"d-flex flex-column align-items-center mt-4"}>
          <Icon size="core" icon={FaBan} />
          <span className={"mt-3"}>This vault item is not used in any Checks</span>
        </div>
      )}
    </div>
  </div>
);
